export default "__VITE_ASSET__CA12JQUx__"